(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-custom-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-addons"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(sec) {
      if (sec._bfReady) return;
      sec._bfReady = true;

      if (sec.classList.contains('bf-add--anim') && !reduce && 'IntersectionObserver' in window) {
        sec.classList.add('is-ready');
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.disconnect(); } });
        }, { threshold: .15 });
        io.observe(sec.querySelector('.bf-add__grid') || sec);
      }

      var toast = sec.querySelector('[data-toast]'), toastT;
      function showToast(html) {
        toast.innerHTML = html;
        toast.classList.add('is-show');
        clearTimeout(toastT);
        toastT = setTimeout(function () { toast.classList.remove('is-show'); }, 2600);
      }

      sec.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-add]');
        if (!btn) return;
        e.preventDefault();
        btn.disabled = true;
        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-add'), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          btn.classList.add('is-done');
          showToast((sec.getAttribute('data-t-added') || 'Added to cart') + ' <a href="' + root + 'cart">View cart</a>');
          setTimeout(function () { btn.classList.remove('is-done'); btn.disabled = false; }, 1600);
        }).catch(function () {
          btn.disabled = false;
          showToast('Could not add to cart. Please try again.');
        });
      });
    }

    function boot(scope) { (scope || document).querySelectorAll('[data-bf-add]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };

    function initCountdown(el) {
      var cd = el.querySelector('[data-cd]');
      if (!cd) return;
      var start = new Date(el.getAttribute('data-start'));
      var end = new Date(el.getAttribute('data-end'));
      if (isNaN(start) || isNaN(end)) return;
      var label = cd.querySelector('[data-cd-label]');
      var time = cd.querySelector('[data-cd-time]');
      function tick() {
        var now = new Date();
        if (now >= end) { cd.hidden = true; return false; }
        var before = now < start;
        var ms = (before ? start : end) - now;
        label.textContent = el.getAttribute(before ? 'data-label-before' : 'data-label-during');
        time.textContent = Math.floor(ms / 864e5) + 'd ' + pad(Math.floor(ms / 36e5) % 24) + ':' +
          pad(Math.floor(ms / 6e4) % 60) + ':' + pad(Math.floor(ms / 1e3) % 60);
        cd.hidden = false;
        return true;
      }
      if (tick()) el._bfTimer = setInterval(function () { if (!tick()) clearInterval(el._bfTimer); }, 1000);
    }

    function initDismiss(el) {
      if (!el.hasAttribute('data-dismissible')) return;
      var key = el.getAttribute('data-key');
      var inEditor = window.Shopify && window.Shopify.designMode;
      try {
        if (!inEditor && window.localStorage.getItem(key) === '1') { el.hidden = true; return; }
      } catch (e) {}
      var btn = el.querySelector('[data-close]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        el.classList.add('is-closing');
        try { window.localStorage.setItem(key, '1'); } catch (e) {}
        setTimeout(function () { el.hidden = true; }, 420);
      });
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-bf-ann]').forEach(function (el) {
        if (el._bfReady) return;
        el._bfReady = true;
        initDismiss(el);
        initCountdown(el);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-bf-ann]').forEach(function (el) { clearInterval(el._bfTimer); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-closing-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = window.matchMedia('(pointer: fine)').matches;

    function init(sec) {
      if (sec._bfReady) return;
      sec._bfReady = true;
      var panel = sec.querySelector('[data-glow]');

      if (sec.classList.contains('bf-cta--anim') && !reduce && 'IntersectionObserver' in window) {
        sec.classList.add('is-ready');
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.disconnect(); } });
        }, { threshold: .25 });
        io.observe(panel);
      }

      /* The glow follows the pointer on desktop */
      if (panel && fine && !reduce) {
        panel.addEventListener('pointermove', function (e) {
          var r = panel.getBoundingClientRect();
          panel.style.setProperty('--gx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          panel.style.setProperty('--gy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
        panel.addEventListener('pointerleave', function () {
          panel.style.removeProperty('--gx');
          panel.style.removeProperty('--gy');
        });
      }
    }

    function boot(scope) { (scope || document).querySelectorAll('[data-bf-cta]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-fine-print-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function fmt(d, tz) {
      var o = { weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' };
      if (tz) o.timeZone = tz;
      try { return d.toLocaleString('en-US', o); } catch (e) { return d.toLocaleString(); }
    }

    function init(sec) {
      if (sec._bfReady) return;
      sec._bfReady = true;

      /* Replace {start} / {end} in answers with the sale dates */
      var start = new Date(sec.getAttribute('data-start'));
      var end = new Date(sec.getAttribute('data-end'));
      var tz = sec.getAttribute('data-tz');
      sec.querySelectorAll('[data-answer]').forEach(function (a) {
        if (a.innerHTML.indexOf('{') < 0) return;
        a.innerHTML = a.innerHTML
          .replace(/\{start\}/g, isNaN(start) ? '' : fmt(start, tz))
          .replace(/\{end\}/g, isNaN(end) ? '' : fmt(new Date(end - 60000), tz));
      });

      /* Smooth open / close */
      var oneOpen = sec.getAttribute('data-one-open') === 'true';
      var items = Array.prototype.slice.call(sec.querySelectorAll('.bf-faq__q'));
      items.forEach(function (d) {
        var summary = d.querySelector('summary'), body = d.querySelector('.bf-faq__a');
        summary.addEventListener('click', function (e) {
          if (reduce || !body.animate) {
            if (oneOpen && !d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
            return;
          }
          e.preventDefault();
          if (d._anim) d._anim.cancel();
          if (d.open) {
            var h = body.offsetHeight;
            d._anim = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 260, easing: 'cubic-bezier(.2,.8,.2,1)' });
            d._anim.onfinish = function () { d.open = false; d._anim = null; };
          } else {
            if (oneOpen) items.forEach(function (o) { if (o !== d && o.open) o.querySelector('summary').click(); });
            d.open = true;
            var full = body.offsetHeight;
            d._anim = body.animate([{ height: '0px', opacity: 0 }, { height: full + 'px', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.2,.8,.2,1)' });
            d._anim.onfinish = function () { d._anim = null; };
          }
        });
      });

      /* Reveal */
      if (sec.classList.contains('bf-faq--anim') && !reduce && 'IntersectionObserver' in window) {
        sec.classList.add('is-ready');
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.disconnect(); } });
        }, { threshold: .15 });
        io.observe(sec);
      }
    }

    function boot(scope) { (scope || document).querySelectorAll('[data-bf-faq]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target.matches && e.target.matches('.bf-faq__q')) e.target.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(ft) {
      if (ft._bfReady) return;
      ft._bfReady = true;
      var btn = ft.querySelector('[data-top]');
      if (!btn) return;
      function onScroll() { btn.classList.toggle('is-show', (window.scrollY || window.pageYOffset) > window.innerHeight * 1.2); }
      window.addEventListener('scroll', onScroll, { passive: true });
      ft._bfScroll = onScroll;
      onScroll();
      btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    }

    function boot(scope) { (scope || document).querySelectorAll('[data-bf-ft]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-bf-ft]').forEach(function (f) { if (f._bfScroll) window.removeEventListener('scroll', f._bfScroll); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };

    function init(el) {
      if (el._bfReady) return;
      el._bfReady = true;

      /* Shadow once the page scrolls; pill appears after N px */
      var pill = el.querySelector('[data-pill]');
      var after = parseInt(el.getAttribute('data-reveal-after'), 10) || 0;
      function onScroll() {
        var y = window.scrollY || window.pageYOffset;
        el.classList.toggle('is-scrolled', y > 4);
        if (pill) pill.classList.toggle('is-visible', y > after);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      el._bfScroll = onScroll;

      /* Countdown inside the pill */
      if (!pill) return;
      var start = new Date(el.getAttribute('data-start'));
      var end = new Date(el.getAttribute('data-end'));
      if (isNaN(start) || isNaN(end)) { pill.hidden = true; return; }
      var label = pill.querySelector('[data-cd-label]');
      var time = pill.querySelector('[data-cd-time]');
      function tick() {
        var now = new Date();
        if (now >= end) { pill.hidden = true; return false; }
        var before = now < start;
        var ms = (before ? start : end) - now;
        label.textContent = el.getAttribute(before ? 'data-label-before' : 'data-label-during');
        time.textContent = Math.floor(ms / 864e5) + 'd ' + pad(Math.floor(ms / 36e5) % 24) + ':' +
          pad(Math.floor(ms / 6e4) % 60) + ':' + pad(Math.floor(ms / 1e3) % 60);
        return true;
      }
      if (tick()) el._bfTimer = setInterval(function () { if (!tick()) clearInterval(el._bfTimer); }, 1000);
    }

    function boot(scope) { (scope || document).querySelectorAll('[data-bf-hdr]').forEach(init); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();

    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-bf-hdr]').forEach(function (el) {
        clearInterval(el._bfTimer);
        if (el._bfScroll) window.removeEventListener('scroll', el._bfScroll);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function set(el, v) {
      if (!el || el.textContent === v) return;
      el.textContent = v;
      if (!reduce) { el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); }
    }

    function init(el) {
      if (el._bfReady) return;
      el._bfReady = true;
      requestAnimationFrame(function () { el.classList.add('is-ready'); });

      var cd = el.querySelector('[data-cd]');
      if (!cd) return;
      var start = new Date(el.getAttribute('data-start'));
      var end = new Date(el.getAttribute('data-end'));
      if (isNaN(start) || isNaN(end)) return;
      var label = cd.querySelector('[data-cd-label]');
      function tick() {
        var now = new Date();
        var phase = now < start ? 'before' : now < end ? 'during' : 'after';
        var ms = Math.max(0, (phase === 'before' ? start : end) - now);
        label.textContent = el.getAttribute('data-label-' + phase) || '';
        set(cd.querySelector('[data-d]'), pad(Math.floor(ms / 864e5)));
        set(cd.querySelector('[data-h]'), pad(Math.floor(ms / 36e5) % 24));
        set(cd.querySelector('[data-m]'), pad(Math.floor(ms / 6e4) % 60));
        set(cd.querySelector('[data-s]'), pad(Math.floor(ms / 1e3) % 60));
        cd.hidden = false;
        return phase !== 'after';
      }
      if (tick()) el._bfTimer = setInterval(function () { if (!tick()) clearInterval(el._bfTimer); }, 1000);
    }

    function boot(scope) { (scope || document).querySelectorAll('[data-bf-hero]').forEach(init); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();

    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-bf-hero]').forEach(function (el) { clearInterval(el._bfTimer); });
    });
    document.addEventListener('shopify:block:select', function (e) {
      var shelf = e.target.closest('[data-shelf]');
      if (shelf) e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-product-lineup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var USE_W = {
      home: { power: .5, quiet: .3, purity: .2 },
      out: { light: .5, battery: .3, quiet: .2 },
      travel: { battery: .5, light: .3, purity: .2 }
    };
    var USE_TXT = { home: 'home use', out: 'out and about', travel: 'travel' };
    var PRIO_TXT = { light: 'weight', battery: 'battery life', quiet: 'low noise', purity: 'purity', price: 'price' };

    function init(sec) {
      if (sec._bfReady) return;
      sec._bfReady = true;

      var currency = sec.getAttribute('data-currency') || 'USD';
      var money = function (c) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency', currency: currency, minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2
          }).format(c / 100);
        } catch (e) { return '$' + (c / 100).toFixed(c % 100 ? 2 : 0); }
      };
      var pct = function (p, w) { return w > p ? Math.round((1 - p / w) * 100) : 0; };
      var T = function (k) { return sec.getAttribute('data-t-' + k) || ''; };
      var $ = function (q, r) { return (r || sec).querySelector(q); };
      var $$ = function (q, r) { return Array.prototype.slice.call((r || sec).querySelectorAll(q)); };
      var list = $('[data-list]');

      /* ---------- Read product data from the markup ---------- */
      var P = $$('[data-prod]').map(function (el) {
        var opts = $$('[data-opt]', el).map(function (o, i) {
          return { i: i, el: o, id: o.getAttribute('data-id'), price: +o.getAttribute('data-price'),
            compare: +o.getAttribute('data-compare'), hrs: +o.getAttribute('data-hrs'), ok: o.getAttribute('data-ok') === 'true' };
        });
        var avail = opts.filter(function (o) { return o.ok; });
        if (!avail.length) avail = opts;
        var picked = opts.filter(function (o) { return o.el.getAttribute('aria-pressed') === 'true'; })[0] || opts[0];
        return {
          el: el, key: el.getAttribute('data-key'), pop: +el.getAttribute('data-pop'),
          tagline: el.getAttribute('data-tagline'), short: el.getAttribute('data-short'), url: el.getAttribute('data-url'),
          weight: parseFloat(el.getAttribute('data-weight')) || 0, weightTxt: el.getAttribute('data-weight-txt'),
          purity: parseFloat(el.getAttribute('data-purity')) || 0, purityTxt: el.getAttribute('data-purity-txt'),
          noise: parseFloat(el.getAttribute('data-noise')) || 0, noiseTxt: el.getAttribute('data-noise-txt'),
          settings: parseFloat(el.getAttribute('data-settings')) || 0,
          pulse: el.getAttribute('data-pulse') === 'true', continuous: el.getAttribute('data-continuous') === 'true',
          flow: el.getAttribute('data-flow'),
          opts: opts, picked: picked,
          maxHrs: Math.max.apply(null, avail.map(function (o) { return o.hrs; }).concat([0])),
          fromPrice: Math.min.apply(null, avail.map(function (o) { return o.price; })),
          bestSave: Math.max.apply(null, avail.map(function (o) { return Math.max(0, o.compare - o.price); }).concat([0])),
          img: (function () { var m = $('img.bf-lu__main-img', el); return m ? (m.currentSrc || m.src) : ''; })()
        };
      });
      if (!P.length) return;

      /* ---------- Normalised scores (0..1, higher = better) ---------- */
      function norm(f, inv) {
        var xs = P.map(f), a = Math.min.apply(null, xs), b = Math.max.apply(null, xs);
        return function (p) { var t = (f(p) - a) / ((b - a) || 1); return inv ? 1 - t : t; };
      }
      var ATTR = {
        light: norm(function (p) { return p.weight; }, true),
        battery: norm(function (p) { return p.maxHrs; }),
        purity: norm(function (p) { return p.purity; }),
        quiet: norm(function (p) { return p.noise; }, true),
        power: norm(function (p) { return (p.settings + (p.continuous ? 4 : 0)) * (p.purity / 95); }),
        price: norm(function (p) { return p.fromPrice; }, true)
      };
      var minOf = function (f) { return Math.min.apply(null, P.map(f)); };
      var maxOf = function (f) { return Math.max.apply(null, P.map(f)); };
      var REASON = {
        light: function (p) { return p.weight === minOf(function (x) { return x.weight; }) ? 'Lightest of the lineup at ' + p.weightTxt : 'Weighs ' + p.weightTxt; },
        battery: function (p) { return 'Up to ' + p.maxHrs + ' hours of battery'; },
        purity: function (p) { return p.purity === maxOf(function (x) { return x.purity; }) ? 'Highest purity in the range: ' + p.purityTxt : 'Oxygen purity ' + p.purityTxt; },
        quiet: function (p) { return p.noise === minOf(function (x) { return x.noise; }) ? 'Quietest of all: ' + p.noiseTxt : 'Runs at ' + p.noiseTxt; },
        power: function (p) { return p.settings + ' settings · ' + p.flow; },
        price: function (p) { return p.fromPrice === minOf(function (x) { return x.fromPrice; }) ? 'Lowest price: ' + money(p.fromPrice) : 'From ' + money(p.fromPrice); }
      };

      /* ---------- Spec bars ---------- */
      P.forEach(function (p) {
        var bt = $('[data-batt-txt]', p.el);
        if (bt) bt.textContent = p.maxHrs ? 'up to ' + p.maxHrs + ' h' : '—';
        $$('[data-r]', p.el).forEach(function (r) {
          var a = ATTR[r.getAttribute('data-r')](p);
          r.classList.toggle('is-best', a === 1);
          r._w = Math.max(8, a * 100) + '%';
        });
      });
      function fillBars(el) { $$('[data-r]', el).forEach(function (r) { $('.bf-lu__trk i', r).style.width = r._w; }); }

      /* ---------- State ---------- */
      var state = { use: null, flow: null, prio: null, filters: {}, sort: 'match', compare: [] };
      var FILTERS = {
        cont: function (p) { return p.continuous; },
        light: function (p) { return p.weight < 4; },
        batt: function (p) { return p.maxHrs >= 12; },
        price: function (p) { return p.fromPrice < (+sec.getAttribute('data-price-under') || 70000); }
      };
      var answered = function () { return !!(state.use || state.flow || state.prio); };

      function scoreOf(p) {
        var w = {};
        if (state.use) Object.keys(USE_W[state.use]).forEach(function (k) { w[k] = (w[k] || 0) + USE_W[state.use][k]; });
        if (state.prio) w[state.prio] = (w[state.prio] || 0) + 1.2;
        var s = 0, tot = 0, contrib = [];
        Object.keys(w).forEach(function (k) { var a = ATTR[k](p); s += a * w[k]; tot += w[k]; contrib.push([k, a * w[k], a]); });
        var score = tot ? s / tot : 0;
        if (state.flow === 'pulse' && !p.pulse) score -= 1;
        if (state.flow === 'continuous' && !p.continuous) score -= 1;
        if (state.flow === 'continuous' && p.continuous && p.purity < 50) score -= .25;
        contrib.sort(function (a, b) { return b[1] - a[1]; });
        return { score: score, contrib: contrib };
      }

      function fitFor(p, contrib) {
        var out = [];
        var add = function (t, warn) { if (out.length < 3 && !out.some(function (o) { return o.t === t; })) out.push({ t: t, warn: warn }); };
        if (state.flow === 'pulse') add(p.pulse ? 'Has pulse flow · ' + p.flow : 'No pulse mode', !p.pulse);
        if (state.flow === 'continuous') add(p.continuous ? 'Has continuous flow · ' + p.flow : 'No continuous flow mode', !p.continuous);
        if (state.prio) add(REASON[state.prio](p));
        contrib.forEach(function (c) { if (c[2] >= .5) add(REASON[c[0]](p)); });
        if (out.length < 2) contrib.forEach(function (c) { add(REASON[c[0]](p)); });
        return out;
      }

      /* ---------- Render ---------- */
      function render() {
        var vis = P.filter(function (p) {
          return Object.keys(state.filters).every(function (k) { return !state.filters[k] || FILTERS[k](p); });
        });
        var scored = {};
        P.forEach(function (p) { scored[p.key] = scoreOf(p); });
        var order = vis.slice().sort(function (a, b) {
          switch (state.sort) {
            case 'price': return a.fromPrice - b.fromPrice;
            case 'save': return b.bestSave - a.bestSave;
            case 'weight': return a.weight - b.weight;
            case 'battery': return (b.maxHrs - a.maxHrs) || (a.weight - b.weight);
            default: return answered() ? (scored[b.key].score - scored[a.key].score) || (a.pop - b.pop) : a.pop - b.pop;
          }
        });

        /* FLIP: remember positions */
        var before = {};
        P.forEach(function (p) { if (!p.el.hidden) before[p.key] = p.el.getBoundingClientRect().top; });

        P.forEach(function (p) { p.el.hidden = vis.indexOf(p) < 0; });
        var lead = order.length ? scored[order[0].key].score : 0;
        var ranked = state.sort === 'match' && answered();
        order.forEach(function (p, i) {
          list.appendChild(p.el);
          var idx = $('[data-idx]', p.el); if (idx) idx.textContent = (i < 9 ? '0' : '') + (i + 1);
          var badge = $('[data-badge]', p.el), sc = scored[p.key];
          p.el.classList.toggle('is-top', ranked && i === 0);
          badge.classList.remove('is-best', 'is-strong');
          if (ranked) {
            var strong = sc.score >= lead - .15;
            badge.textContent = i === 0 ? T('best') : strong ? T('strong') : T('also');
            if (i === 0) badge.classList.add('is-best'); else if (strong) badge.classList.add('is-strong');
          } else badge.textContent = p.tagline;
          var fit = $('[data-fit]', p.el);
          if (answered()) {
            fit.innerHTML = '<span class="bf-lu__lbl">' + T('fit') + '</span><ul class="bf-lu__ticks">' +
              fitFor(p, sc.contrib).map(function (o) { return '<li class="' + (o.warn ? 'is-warn' : '') + '">' + o.t + '</li>'; }).join('') + '</ul>';
            fit.hidden = false;
          } else { fit.hidden = true; fit.innerHTML = ''; }
        });

        /* FLIP: animate to new positions */
        if (!reduce) P.forEach(function (p) {
          if (p.el.hidden || before[p.key] === undefined) return;
          var dy = before[p.key] - p.el.getBoundingClientRect().top;
          if (dy && p.el.animate) p.el.animate([{ transform: 'translateY(' + dy + 'px)' }, { transform: 'none' }], { duration: 450, easing: 'cubic-bezier(.2,.8,.2,1)' });
        });

        var empty = $('[data-empty]'); if (empty) empty.hidden = vis.length > 0;
        var count = $('[data-count]'); if (count) count.innerHTML = '<b>' + vis.length + '</b> of ' + P.length + ' models';
        var nf = Object.keys(state.filters).filter(function (k) { return state.filters[k]; }).length;
        var fc = $('[data-fcount]'); if (fc) fc.textContent = nf || '';
        var ctx = $('[data-context]');
        if (ctx) {
          var parts = [];
          if (ranked && vis.length) {
            if (state.use) parts.push('for ' + USE_TXT[state.use]);
            if (state.flow) parts.push('with ' + state.flow + ' flow');
            if (state.prio) parts.push('where ' + PRIO_TXT[state.prio] + ' matters most');
          }
          ctx.textContent = parts.length ? 'Ranked ' + parts.join(', ') + '.' : '';
        }
        $$('[data-q]').forEach(function (b) { b.setAttribute('aria-pressed', state[b.getAttribute('data-q')] === b.getAttribute('data-v')); });
        $$('[data-f]').forEach(function (c) { c.checked = !!state.filters[c.getAttribute('data-f')]; });
        var sort = $('[data-sort]'); if (sort) sort.value = state.sort;
      }

      /* ---------- Variant switch ---------- */
      function pick(p, o) {
        p.picked = o;
        p.opts.forEach(function (x) { x.el.setAttribute('aria-pressed', x === o); });
        var pr = $('[data-p]', p.el);
        pr.textContent = money(o.price);
        if (!reduce) { pr.classList.remove('is-bump'); void pr.offsetWidth; pr.classList.add('is-bump'); }
        $('[data-w]', p.el).textContent = o.compare > o.price ? money(o.compare) : '';
        $('[data-sv]', p.el).textContent = o.compare > o.price ? T('save') + ' ' + money(o.compare - o.price) : '';
        var off = $('[data-off]', p.el); if (off) off.textContent = '−' + pct(o.price, o.compare) + '%';
        var buy = $('[data-buy]', p.el);
        buy.href = p.url + '?variant=' + o.id;
        buy.setAttribute('data-variant', o.id);
      }

      /* ---------- Buy: product page, cart or checkout ---------- */
      var action = sec.getAttribute('data-buy-action') || 'product';
      sec.addEventListener('click', function (e) {
        var buy = e.target.closest('[data-buy]');
        if (!buy || action === 'product') return;
        e.preventDefault();
        var label = buy.textContent;
        buy.classList.add('is-loading'); buy.textContent = T('adding');
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +buy.getAttribute('data-variant'), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = action === 'checkout' ? '/checkout' : '/cart';
        }).catch(function () {
          buy.classList.remove('is-loading'); buy.textContent = label;
          window.location.href = buy.href;
        });
      });

      /* ---------- Events ---------- */
      sec.addEventListener('click', function (e) {
        var q = e.target.closest('[data-q]');
        if (q) {
          var k = q.getAttribute('data-q'), v = q.getAttribute('data-v');
          state[k] = state[k] === v ? null : v;
          state.sort = 'match';
          render(); return;
        }
        if (e.target.closest('[data-reset]')) {
          state.use = state.flow = state.prio = null; state.filters = {}; state.sort = 'match';
          render(); return;
        }
        var t = e.target.closest('.bf-lu__thumbs button');
        if (t) {
          var prod = t.closest('[data-prod]'), main = $('.bf-lu__main-img', prod), isCut = t.getAttribute('data-cut') === 'true';
          $$('.bf-lu__thumbs button', prod).forEach(function (b) { b.setAttribute('aria-current', b === t); });
          if (!main || main.tagName !== 'IMG') return;
          main.classList.add('is-swapping');
          var src = t.getAttribute('data-src');
          var img = new Image();
          img.onload = img.onerror = function () {
            main.removeAttribute('srcset'); main.removeAttribute('sizes');
            main.src = src; main.classList.toggle('is-cut', isCut);
            requestAnimationFrame(function () { main.classList.remove('is-swapping'); });
          };
          img.src = src;
          return;
        }
        var o = e.target.closest('[data-opt]');
        if (o && !o.disabled) {
          var p = P.filter(function (x) { return x.el.contains(o); })[0];
          pick(p, p.opts.filter(function (x) { return x.el === o; })[0]);
          return;
        }
        var more = $('[data-more]');
        if (more && more.open && !e.target.closest('[data-more]')) more.open = false;
      });
      document.addEventListener('click', function (e) {
        var more = $('[data-more]');
        if (more && more.open && !sec.contains(e.target)) more.open = false;
      });

      sec.addEventListener('change', function (e) {
        var f = e.target.closest('[data-f]');
        if (f) { state.filters[f.getAttribute('data-f')] = f.checked; render(); return; }
        if (e.target.matches('[data-sort]')) { state.sort = e.target.value; render(); return; }
        var c = e.target.closest('[data-cmp]');
        if (c) {
          var key = c.closest('[data-prod]').getAttribute('data-key');
          var max = +sec.getAttribute('data-compare-max') || 3;
          if (c.checked) {
            if (state.compare.length >= max) { c.checked = false; flash('Compare up to ' + max + ' at a time'); return; }
            state.compare.push(key);
          } else state.compare = state.compare.filter(function (k) { return k !== key; });
          renderTray();
        }
      });

      /* ---------- Compare ---------- */
      var tray = $('[data-tray]'), sheet = $('[data-sheet]'), flashT;
      function byKey(k) { return P.filter(function (p) { return p.key === k; })[0]; }
      function flash(msg) { var t = $('[data-tray-text]'); if (!t) return; t.textContent = msg; clearTimeout(flashT); flashT = setTimeout(renderTray, 1800); }
      function renderTray() {
        if (!tray) return;
        var ps = state.compare.map(byKey);
        tray.classList.toggle('is-open', ps.length > 0);
        $('[data-tray-thumbs]').innerHTML = ps.map(function (p) { return '<span><img src="' + p.img + '" alt="' + p.short + '"></span>'; }).join('');
        $('[data-tray-text]').textContent = ps.length < 2 ? 'Pick 1 more to compare' : ps.length + ' models selected';
        $('[data-tray-go]').disabled = ps.length < 2;
        $$('[data-cmp]').forEach(function (c) { c.checked = state.compare.indexOf(c.closest('[data-prod]').getAttribute('data-key')) > -1; });
      }
      if (tray) {
        $('[data-tray-clear]').addEventListener('click', function () { state.compare = []; renderTray(); });
        $('[data-tray-go]').addEventListener('click', function () {
          var ps = state.compare.map(byKey);
          var rows = [
            ['Price', function (p) { return [p.picked.price, money(p.picked.price) + (p.picked.compare > p.picked.price ? ' <s style="opacity:.5;font-weight:400">' + money(p.picked.compare) + '</s>' : '')]; }, 'min'],
            ['You save', function (p) { var v = Math.max(0, p.picked.compare - p.picked.price); return [v, money(v)]; }, 'max'],
            ['Weight', function (p) { return [p.weight, p.weightTxt]; }, 'min'],
            ['Battery', function (p) { return [p.maxHrs, 'up to ' + p.maxHrs + ' h']; }, 'max'],
            ['Oxygen', function (p) { return [p.purity, p.purityTxt]; }, 'max'],
            ['Noise', function (p) { return [p.noise, p.noiseTxt]; }, 'min'],
            ['Settings', function (p) { return [p.settings, p.settings]; }, 'max'],
            ['Flow', function (p) { return [null, p.flow]; }, null]
          ];
          $('[data-ctable]').innerHTML =
            '<thead><tr><th></th>' + ps.map(function (p) { return '<th><img src="' + p.img + '" alt="">' + p.short + '<br><span class="bf-lu__lbl">' + p.tagline + '</span></th>'; }).join('') + '</tr></thead><tbody>' +
            rows.map(function (r) {
              var vals = ps.map(r[1]), nums = vals.map(function (v) { return v[0]; });
              var best = r[2] === 'min' ? Math.min.apply(null, nums) : r[2] === 'max' ? Math.max.apply(null, nums) : null;
              var unique = best !== null && nums.filter(function (n) { return n === best; }).length < nums.length;
              return '<tr><td>' + r[0] + '</td>' + vals.map(function (v) { return '<td class="' + (unique && v[0] === best ? 'is-win' : '') + '">' + v[1] + '</td>'; }).join('') + '</tr>';
            }).join('') +
            '<tr><td></td>' + ps.map(function (p) { return '<td><a class="bf-lu__btn" href="' + p.url + '?variant=' + p.picked.id + '">Get this deal</a></td>'; }).join('') + '</tr></tbody>';
          if (sheet.showModal) sheet.showModal(); else sheet.setAttribute('open', '');
        });
        $('[data-sheet-close]').addEventListener('click', function () { sheet.close(); });
        sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
      }

      /* ---------- Reveal + bars on scroll ---------- */
      if (sec.classList.contains('bf-lu--anim') && 'IntersectionObserver' in window && !reduce) {
        sec.classList.add('is-ready');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            en.target.classList.add('is-in');
            fillBars(en.target);
            io.unobserve(en.target);
          });
        }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });
        P.forEach(function (p) { io.observe(p.el); });
      } else {
        P.forEach(function (p) { p.el.classList.add('is-in'); fillBars(p.el); });
      }

      render();
      renderTray();
    }

    function boot(scope) { (scope || document).querySelectorAll('[data-bf-lu]').forEach(init); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();

    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var prod = e.target.closest('[data-prod]');
      if (prod) { prod.classList.add('is-in'); prod.hidden = false; }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-story-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(sec) {
      if (sec._bfReady) return;
      sec._bfReady = true;
      var anim = sec.classList.contains('bf-story--anim') && !reduce && 'IntersectionObserver' in window;

      if (anim) {
        sec.classList.add('is-ready');
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); io.disconnect(); } });
        }, { threshold: .2 });
        io.observe(sec);
      }

      /* Gentle parallax on the big image */
      var media = sec.querySelector('[data-parallax]');
      var img = media && media.querySelector('.bf-story__img');
      if (!img || reduce) return;
      var ticking = false;
      function update() {
        ticking = false;
        var r = media.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom < 0 || r.top > vh) return;
        var progress = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.setProperty('--st-shift', (progress * -40).toFixed(1) + 'px');
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      sec._bfScroll = onScroll;
      update();
    }

    function boot(scope) { (scope || document).querySelectorAll('[data-bf-story]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-bf-story]').forEach(function (s) { if (s._bfScroll) window.removeEventListener('scroll', s._bfScroll); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
